/**
 * "Most-read" on the Help Center home: the questions customers ask most,
 * from 190 concierge chats and 119 requests to the team (Jun–Oct 2026),
 * most-asked first. Ids are `section/slug`; help-content.test.js fails on
 * one that doesn't exist.
 */
export const POPULAR_ARTICLE_IDS = Object.freeze([
  'confirmation-and-travel/when-confirmation-number',
  'payments/payment-not-showing',
  'changes-cancellations/what-is-defera-credit',
  'changes-cancellations/change-your-flight',
  'seats-and-bags/buy-seats-after-booking',
  'changes-cancellations/cancel-your-trip',
  'payments/skip-a-payment',
  'payments/update-card',
  'contact/check-request-status',
  'changes-cancellations/correct-traveler-details',
]);
